<template lang="pug">
	.template-settings(v-if="showed" v-window)
		.card
			.card-header
				i.fa.fa-edit
				span {{ getTypeTitle() }} Template Settings
				.entity-id(v-if="templateProps") Template Id: {{templateProps.id}}
			.card-body.collapse.show
				.form-horizontal
					.form-group
						label.col-form-label Template title
							.controls
								input.form-control.title(size="16" type="text" v-model="title" @input="updateTitle")
					.form-group
						label.col-form-label Description
						textarea.form-control.description(rows="1" v-model="description" @input="updateDescription")
					.form-group.separator
						label Publisher
						select.publisher-select.custom-select.form-control(v-model="publisherId" @change="updatePublisher")
							option(:value="0") Any publisher
							option(v-for="publisher in Publisher.getAllPublishers()" v-if="publisher.active || Publisher.isSelectedPublisher(publisher)" :value="publisher.id") {{publisher.title}}
					.form-group.sizes.separator(v-if="templateProps")
						label.col-form-label Sizes
						.sizes-list(v-if="sizes.length")
							.size-item(v-for="size in sizes" :key="`${size.width}x${size.height}`")
								input.form-control.size-title(type="text" placeholder="Size title" v-model="size.title" @input="updateSizeTitle(size)")
								span.size-dimensions {{size.width}} x {{size.height}}
								.progress.size-progress(v-if="updatingSizeKey === `${size.width}x${size.height}`")
									.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (sizeUploadProgress * 100) + '%'}")
								i.fa.fa-upload.update-size(@click="updateSize(size)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Update this size by uploading a psd file'}")
								i.fa.fa-remove.remove-size(@click="deleteSize(size)" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'Remove this size'}")
						.text-muted.no-sizes(v-else) No sizes yet
						.error-message.text-danger(v-if="sizeErrorMessage") {{ sizeErrorMessage }}
					.progress.add-progress(:style="{display: isUploading ? 'block' : 'none'}")
						.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (uploadProgress * 100) + '%'}")
					.form-actions
						button.btn.btn-danger(type="button" v-if="templateProps" @click="deleteTemplate()" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'This will mark the template as inactive'}")
							i.fa.fa-trash
							span Delete template
						button.btn.btn-danger(type="button" v-if="versionId && templateProps" @click="updateTemplate()" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'Update template metadata'}")
							i.fa.fa-save
							span Update
						button.btn.btn-primary(type="button" v-if="versionId && !templateProps" @click="saveTemplate()" v-b-tooltip.hover.v-primary="{delay: { show: 500, hide: 100 }, title: 'Save template in metadata'}")
							i.fa.fa-save
							span Save as {{ getType().toLowerCase() }} template
						button.btn.btn-primary(type="button" v-if="templateProps" v-on:click="uploadIcon()")
							i.fa.fa-upload
							span Upload icon
						button.btn.btn-dark(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen';
	import { Auth } from "../../services/Auth";

	import { Creative } 			from './../../services/Creative';
	import { Version } 			from './../../services/Version';
	import { Settings } 		from './../../services/Settings';
	import { Asset } 			from './../../services/Asset';
	import SetupSettings 		from "./../../settings/settings";

	export default {
		name: "TemplateSettings",
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				"Show TemplateSettings": function(versionId, templateId, type) {

					this.versionId = versionId;
					this.templateId = templateId;
					this.type = type;

					this.update();

				},
				"Show BannerTemplateSettings": function(versionId, templateBannerId) {

					this.versionId = versionId;
					this.templateId = templateBannerId;
					this.type = 'banner';

					this.update();

				},
				"Show StoryboardTemplateSettings": function(versionId, templateStoryboardId) {

					this.versionId = versionId;
					this.templateId = templateStoryboardId;
					this.type = 'storyboard';

					this.update();

				},
				"Server Data:TemplateSizeUpdated": function(templateCodename) {

					if (!this.templateProps || this.templateProps.codename !== templateCodename) return;

					this.stopSizeUploading();
					this.collectData();

				},
				"Server Data:TemplateSizeError": function(errorMessage) {

					this.stopSizeUploading();

					if (this.showed) this.sizeErrorMessage = errorMessage;

				}
			}
		},
		data() {

			this.Creative = Creative;
			this.Version = Version;
			this.Settings = Settings;

			this.templateProps = null;

			return {
				title: 'New Template',
				description: '',
				versionId: 0,
				templateId: 0,
				type: null,
				publisherId: 0,
				isUploading: false,
				uploadProgress: 0,
				iconsCounter: 1,
				sizes: [],
				updatingSizeKey: '',
				sizeUploadProgress: 0,
				sizeErrorMessage: ''
			}
		},
		methods: {
			getType() {

				if (this.type) return this.type;

				if (this.versionId) {
					let version = Version.getVersion(this.versionId);
					if (version) {
						let creative = Creative.getCreative(version["creative_id"]);
						if (creative?.type) return creative.type;
						if (version.options?.templateId) {
							let t = Metadata.Templates?.[version.options.templateId];
							if (t?.type) return t.type;
						}
					}
				}

				if (this.templateId) {
					let t = Metadata.Templates?.[this.templateId];
					if (t?.type) return t.type;
				}

				return Creative.SelectedCreative?.type || 'banner';

			},
			getTypeTitle() {

				let type = this.getType();
				if (type === 'storyboard') return 'Storyboard';
				return 'Banner';

			},
			collectData() {

				if (this.templateId) {
					this.templateProps = Metadata.Templates?.[this.templateId];
				} else if (this.versionId) {
					let version = Version.getVersion(this.versionId);
					let templateId = version?.options?.templateId;
					this.templateProps = Metadata.Templates?.[templateId];
				}

				if (this.templateProps) {

					this.title = this.templateProps?.title;
					this.description = this.templateProps?.description || '';
					this.publisherId = this.templateProps["publisher_id"];
					this.sizes = _.cloneDeep(this.templateProps.options?.sizes || []);

				} else {

					this.title = `New ${this.getTypeTitle()} Template`;
					this.description = '';
					this.publisherId = 0;
					this.sizes = [];

				}

			},
			updateTitle() {

				if (!this.templateProps) return;

				Server.sendWithTimeout({
					RenameTemplate: {
						templateCodename: this.templateProps.codename,
						title: this.title.trim()
					}
				}, null, 200);

			},
			updateDescription() {

				if (!this.templateProps) return;

				Server.sendWithTimeout({
					UpdateTemplateDescription: {
						templateCodename: this.templateProps.codename,
						description: this.description.trim()
					}
				}, null, 200);

			},
			updateSizeTitle(size) {

				if (!this.templateProps) return;

				Server.sendWithTimeout({
					RenameTemplateSize: {
						templateCodename: this.templateProps.codename,
						width: size.width,
						height: size.height,
						title: size.title.trim()
					}
				}, `RenameTemplateSize-${size.width}x${size.height}`, 200);

			},
			deleteSize(size) {

				if (!this.templateProps) return;

				Broadcast.call('Show Confirm', [{
					caption: 'Delete size',
					message: `Are you sure you want to delete size ${size.width} x ${size.height}?`,
					confirmButtonText: '&nbsp;&nbsp;Delete size',
					confirmButtonIcon: 'fa-remove',
					confirmCallback: () => {

						Server.sendToSocket({
							DeleteTemplateSize: {
								templateCodename: this.templateProps.codename,
								width: size.width,
								height: size.height
							}
						});

						this.sizes = _.reject(this.sizes, s => s.width === size.width && s.height === size.height);

					}
				}]);

			},
			updateSize(size) {

				if (!this.templateProps || this.updatingSizeKey) return;

				Broadcast.call('Show Confirm', [{
					caption: 'Replace size',
					message: `Are you sure you want to replace size ${size.width} x ${size.height} by uploading a new psd file?`,
					confirmButtonText: '&nbsp;&nbsp;Replace size',
					confirmButtonIcon: 'fa-upload',
					confirmButtonClass: 'btn-primary',
					confirmCallback: () => {

						Asset.requestFile(".psd,.psb", file => {

							if (file) this.uploadSizeFile(size, file);

						});

					}
				}]);

			},
			stopSizeUploading() {

				this.updatingSizeKey = '';
				this.sizeUploadProgress = 0;

			},
			uploadSizeFile(size, file) {

				this.updatingSizeKey = `${size.width}x${size.height}`;
				this.sizeUploadProgress = 0;
				this.sizeErrorMessage = '';

				let formData = new FormData();
				formData.append("templateCodename", this.templateProps.codename);
				formData.append("width", size.width);
				formData.append("height", size.height);
				formData.append("file", file);

				let url = `${location.protocol}//${SetupSettings["domain"]}/template/updateTemplateSize`;

				let xhr = new XMLHttpRequest();


				xhr.open("POST", url);
				Auth.authorizeRequest(xhr);

				xhr.upload.onprogress = e => {

					if (e.lengthComputable) this.sizeUploadProgress = e.loaded / e.total;

				};

				// Результат (обновлённые метаданные шаблона) придёт через сокет в Server Data:TemplateSizeUpdated / TemplateSizeError
				xhr.send(formData);

			},
			updatePublisher() {

				if (!this.templateProps) return;

				Server.sendWithTimeout({
					ChangeTemplatePublisher: {
						templateCodename: this.templateProps.codename,
						publisherId: this.publisherId
					}
				}, null, 200);

			},
			uploadIcon() {

				this.uploadProgress = 0;

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.accept = "image/png, image/jpeg, image/gif";

				input.addEventListener('change', e => {

					this.uploadIconFile(e.target.files[0]);

					document.body.removeChild(input);

				});

				input.addEventListener('blur', () => {

					document.body.removeChild(input);

				});

				input.click();

			},
			uploadIconFile(file) {

				let formData = new FormData();
				formData.append("templateCodename", this.templateProps.codename);
				formData.append("file", file);
				let url = `${location.protocol}//${SetupSettings["domain"]}/template/updateTemplateIcon`;

				let xhr = new XMLHttpRequest();


				xhr.open("POST", url);
				Auth.authorizeRequest(xhr);

				xhr.upload.onprogress = e => {

					if (e.lengthComputable) {

						this.uploadProgress = e.loaded / e.total;

					}

				};

				xhr.upload.onloadstart = () => {

					this.isUploading = true;

				};

				xhr.upload.onloadend = () => {

					this.isUploading = false;

					if (this.templateProps) {
						this.templateProps.iconVersion = Date.now();
						if (this.templateProps.options) {
							this.templateProps.options.iconVersion = Date.now();
						}
					}

				};

				xhr.send(formData);

			},
			updateTemplate() {

				Server.sendToSocket({
					RequestTemplateUpdateInfo: {
						templateCodename: this.templateProps.codename,
						versionId: this.versionId
					}
				});

				Broadcast.once("Server Data:UpdateTemplateInfo", (info) => {

					Broadcast.call('Show TemplateUpdate', [this.versionId, info, this.getType()]);

					this.hide();

				});

			},
			deleteTemplate() {

				let typeTitle = this.getTypeTitle().toLowerCase();

				Broadcast.call('Show Confirm', [{
					caption: `Delete ${typeTitle} template`,
					message: `Are you sure you want to delete ${typeTitle} template "${this.templateProps.title}"?`,
					confirmButtonText: '&nbsp;&nbsp;Delete template',
					confirmButtonIcon: 'fa-remove',
					confirmCallback: () => {

						Server.sendToSocket({
							DeleteTemplate: {
								templateCodename: this.templateProps.codename
							}
						});

						this.hide();

					}
				}]);

			},
			saveTemplate() {

				let type = this.getType();
				let typeTitle = this.getTypeTitle().toLowerCase();

				Broadcast.call('Show Confirm', [{
					caption: `Create ${typeTitle} template`,
					message: `Are you sure you want to create new ${typeTitle} template with name "${this.title.trim()}"?`,
					confirmButtonText: '&nbsp;&nbsp;Create template',
					confirmButtonIcon: 'fa-floppy-o',
					confirmButtonClass: 'btn-primary',
					confirmCallback: () => {

						Server.sendToSocket({
							CreateTemplate: {
								versionId: this.versionId,
								title: this.title.trim(),
								publisherId: this.publisherId,
								type: type
							}
						});

						this.hide();

					}
				}]);

			}
		}
	}
</script>


<style lang="sass">

	.template-settings, .banner-template-settings
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s

		.entity-id
			position: absolute
			top: 19px
			right: 19px
			opacity: 0.2

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 600px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input.title, textarea.description
				width: 460px
				margin-top: 5px

			textarea.description
				resize: vertical

			select.publisher-select
				width: 250px

			.sizes-list
				display: flex
				flex-direction: column
				margin-top: 5px
				max-height: 200px
				overflow-y: auto
				overflow-x: hidden

				.size-item
					display: flex
					flex-direction: row
					align-items: center
					margin-bottom: 5px

					.size-title
						margin-right: 10px
						min-width: 0
						width: 300px

						&:focus
							outline: none
							box-shadow: none
							border-color: inherit

					.size-dimensions
						font-weight: bold
						white-space: nowrap
						margin-right: 10px

					.progress.size-progress
						width: 60px
						height: 5px
						margin-right: 10px

					.update-size, .remove-size
						cursor: pointer
						opacity: 0.6
						margin-left: 10px
						// Область наведения/клика увеличена вдвое по площади, при этом визуальный размер иконки не меняется
						padding: 8px
						margin: 0 -4px 0 6px
						box-sizing: content-box

						&:hover
							opacity: 1

					.update-size
						font-size: 14px
						margin-left: auto

					.remove-size
						font-size: 18px

					.remove-size:hover
						color: var(--red, #f86c6b)

					.update-size:hover
						color: var(--primary, #20a8d8)

			.no-sizes
				margin-top: 5px

			.sizes .error-message
				margin-top: 5px

			.btn-danger, .btn-primary
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.switch-slider
				background-color: #343b41
				border: 1px solid #23282c

			.progress.add-progress
				height: 5px
				margin-top: 10px
				margin-bottom: 10px

		.form-group
			display: flex
			flex-direction: column

		.form-actions
			margin-top: 20px

	.template-settings.hiding, .banner-template-settings.hiding
		opacity: 0

		.card
			transform: scale(0.9)

</style>
